<script lang="ts">
    let classes = '';
    export { classes as class };
</script>

<svg class={classes} xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27" fill="none">
    <rect x="13.0918" width="18.5146" height="18.5146" transform="rotate(45 13.0918 0)" fill="#477685" />
    <rect
        width="1.125"
        height="10.8015"
        transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 19.001 9.97815)"
        fill="white"
    />
    <rect
        width="1.125"
        height="5.40073"
        transform="matrix(-0.707107 0.707107 0.707107 0.707107 8.02051 13.3196)"
        fill="white"
    />
</svg>
